import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { Dropdown, Menu, Layout, Typography, Row, Col, Space } from 'antd';
import { UserOutlined } from '@ant-design/icons';

import ownerLogo from '../images/brand.png';

import AccountMenu from './AccountMenu';
import MessageButton from './MessageButton';

const { Text } = Typography;
const { Header } = Layout;

const caption = "Nu-Med Labs";

class ToolBar extends Component {

    handleEvent = (e) => {
        this.props.appStore.navigateTo(e.key);
    }

    renderRoleTabs = () => {
        const appStore = this.props.appStore;
        if (!appStore.isLoggedIn()) {
            return (
                <>
                    <Col span={20} style={{ textAlign: "center" }} >
                        <Text style={{ color: "rgb(69,49,28)" }} strong={true}>Master Data Management</Text>
                    </Col>
                </>
            )
        }

        return (
            <Col span={15}>
                <Menu mode="horizontal" defaultSelectedKeys={['0']}>
                    {
                        appStore.menus.map((item, index) => (
                            <Menu.Item key={index} className="customclass" onClick={this.handleEvent} >{item.label}</Menu.Item>)
                        )
                    }
                </Menu>
            </Col>
        )
    }

    renderRightMenu = () => {
        const appStore = this.props.appStore;
        if (appStore.isLoggedIn()) {
            return (
                <Col span={6} style={{ textAlign: "right" }}>
                    <Space>
                        <MessageButton appStore={appStore} />
                        <Dropdown.Button overlay={<AccountMenu appStore={appStore} />} trigger={['click']} icon={<UserOutlined />}>
                            {appStore.credentials.username}
                        </Dropdown.Button>
                    </Space>
                </Col>
            )
        }
    }

    render() {
        return (
            <Header style={{ position: 'fixed', zIndex: 1, width: '100%', background: '#fff', padding: "0px 5px 0px 5px" }}>
                <Row>
                    <Col style={{ paddingTop: 5 }} span={2}>
                        <img alt="Nu-Med Labs Logo" src={ownerLogo} align="left" width="103" height="50" title={caption} />
                    </Col>
                    {this.renderRoleTabs()}
                    {this.renderRightMenu()}
                </Row>
            </Header>
        )
    }
}

export default observer(ToolBar);